// App.tsx
import { useRoutes, useLocation } from "react-router-dom";
import routes from "./routes";
import { useEffect } from "react";
import DocumentTitleSync from "./components/document-title-sync";

function App() {
  const { pathname } = useLocation();
  const element = useRoutes(routes);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <DocumentTitleSync />
      {element}
    </>
  );
}

export default App;